import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import * as colors from '../../../common/colorConstants';
import { processRbiGiftCardTransferring } from '../../../../actions/tools/RBIActions';
import { getDecisionNodeAtPath } from '../../../../extractFromState';
import { clearToolsRbiCustomerStore } from '../../../../actions/creatorsSync';
import { maskCardNumber } from '../../../../util';
import { HeaderContainer, SpinnerWrapper, Spinner, SubTitle, Title } from '../../DecisionTree.styles';
import {
  Button,
  TransferringContainer,
  InputRow,
  InputLabel,
  Input,
  CheckIcon,
} from './DTRBITransferGiftCardFundsNode.styles';

const DTRBITransferGiftCardFundsNode = () => {
  const [email, setEmail] = useState('');
  const [cardNumber, setCardNumber] = useState('');
  const [maskedCardNumber, setMaskedCardNumber] = useState('');
  const dispatch = useDispatch();

  const decisionNode = useSelector((state) => getDecisionNodeAtPath(state));
  const customerCard = useSelector((state) => state.tools.decisionTree.rbi.customer?.cardNumber);
  const isLoading = useSelector(
    (state) => state.ui.loading.isLoading && state.ui.loading.component === 'giftCardTransferring'
  );

  useEffect(() => {
    if (customerCard) {
      setCardNumber(customerCard);
      setMaskedCardNumber(maskCardNumber(customerCard));
    }

    return () => {
      dispatch(clearToolsRbiCustomerStore());
    };
  }, [dispatch, customerCard]);

  const handleTransferring = () => {
    dispatch(processRbiGiftCardTransferring(cardNumber.trim(), email));
  };

  return (
    <>
      <HeaderContainer>
        {decisionNode?.title && <Title>{decisionNode.title}</Title>}
        {decisionNode?.subText && <SubTitle>{decisionNode.subText}</SubTitle>}
      </HeaderContainer>

      {isLoading ? (
        <SpinnerWrapper>
          <Spinner color={colors.purple1} />
        </SpinnerWrapper>
      ) : (
        <TransferringContainer>
          <InputRow>
            <InputLabel htmlFor="card-number">Previous card number</InputLabel>
            <Input
              id="card-number"
              placeholder="Enter previous card number"
              readOnly={!!customerCard}
              value={maskedCardNumber ? maskedCardNumber : cardNumber}
              onChange={(e) => setCardNumber(e.target.value)}
            />
            {customerCard && <CheckIcon src={'/images/green_check.svg'} alt="check" />}
          </InputRow>
          <InputRow>
            <InputLabel htmlFor="receiver-email">Type new email to link to balance</InputLabel>
            <Input
              id="receiver-email"
              value={email}
              onChange={(e) => setEmail(e.target.value.trim())}
              placeholder="Enter new email address"
            />
          </InputRow>
          <Button id="submitTransferring" active={true} onClick={handleTransferring}>
            Transfer
          </Button>
        </TransferringContainer>
      )}
    </>
  );
};

export default DTRBITransferGiftCardFundsNode;
